/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://d3itdk675fdxpdvex4mbwuuemm.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_cognito_identity_pool_id": "eu-central-1:a2feed0b-c6d1-479e-9e9f-d12bd3ee84e3",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_8Wy0l0X1F",
    "aws_user_pools_web_client_id": "43dg2cpchuhf6q233vm21d9e4j",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "mixer-storage235657-dev",
    "aws_user_files_s3_bucket_region": "eu-central-1"
};


export default awsmobile;
